import { jsx as _jsx } from "react/jsx-runtime";
import './Captions.css';
export const Captions = ({ text, visible }) => {
    if (!visible || !text) {
        return null;
    }
    return (_jsx("div", { className: "captions", role: "status", "aria-live": "polite", "aria-atomic": "true", children: text }));
};
